<template>
	<div ref="chart" style="width: 100%; height: 100%; min-height: 100px"></div>
</template>

<script>
	import * as echarts from 'echarts';

	export default {
		name: 'BaseChart',
		props: {
			option: Object,
		},
		data() {
			return {
				chart: null,
			};
		},
		watch: {
			option: {
				deep: true,
				handler(val) {
					this.chart && this.chart.setOption(val, true);
				},
			},
		},
		mounted() {
			this.chart = echarts.init(this.$refs.chart);
			this.chart.setOption(this.option);
			window.addEventListener('resize', this.resize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize);
			this.chart && this.chart.dispose();
		},
		methods: {
			resize() {
				this.chart && this.chart.resize();
			},
		},
	};
</script>
